import React, { useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Divder from '../../Components/CommonComp/Divder';
import CustomBox from '../../Components/CommonComp/CustomBox/CustomBox';
import { LeftArrow } from '../../Asset/svg';
import { Typography, useTheme } from '@mui/material';
import { useReactToPrint } from 'react-to-print';
import CustomButton from '../../Components/CommonComp/Buttons/CustomButton';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearSingleUserDetails } from '../../redux/user';
import { ChalanInvoicePage } from '../../Components/Chalan/ChalanInvoicePage';

function BillingInvoiceDetails({ isEdit }) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [applyPageBreak, setApplyPageBreak] = useState(false);
  const componentRef = useRef(null);
  const { billingId } = useParams();
  const handlePrint = useReactToPrint({
    content: () => componentRef?.current,
    pageStyle: '@page { size: auto; margin: 12mm 5mm; } }',
    // print: async (printIframe) => {
    //   // Do whatever you want here, including asynchronous work
    //   // get generated pdf content from generatePDFFunction function
    //   // await generatePDFFunction(printIframe);
    // },
  });

  const handlePrint2 = async () => {
    // Access the current property of the ref to get the component instance
    const componentInstance = componentRef.current;

    if (componentInstance) {
      const combinedHeight = componentInstance.offsetHeight;
      if (combinedHeight > 800) {
        await setApplyPageBreak(true); // Adjust this value based on A4 size
      } else {
        await setApplyPageBreak(false); // Adjust this value based on A4 size
      }
      await handlePrint();
    }
  };
  return (
    <Box
      component="main"
      sx={(theme) => {
        return {
          flexGrow: 1,
          // bgcolor: theme.backgroundColor.box.main,
          // p: 4,
          // pl: 0,
        };
      }}
    >
      <CustomBox>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            onClick={() => {
              navigate(-1);
              dispatch(clearSingleUserDetails());
            }}
          >
            <LeftArrow fill={theme.palette.textButton.main} />
            <Typography
              variant="h5"
              sx={{
                marginLeft: theme.spacing(1),
                color: theme.palette.textButton.main,
              }}
            >
              Back
            </Typography>
          </Box>
          <Typography
            variant="h5"
            sx={{ marginLeft: (theme) => theme.spacing(1) }}
          >
            Invoice
          </Typography>
          <CustomButton
            onClick={() => {
              handlePrint2();
            }}
            sx={{
              padding: '5px 10px',
              marginRight: 1,
              fontSize: '14px',
              bgcolor: 'buttonFive.main',
              color: 'buttonFive.contrastText',
            }}
          >
            Print
          </CustomButton>
          {/* <Typography */}
        </Box>
      </CustomBox>
      <Divder spacing={1} />
      <ChalanInvoicePage
        ref={componentRef}
        billingId={billingId}
        applyPageBreak={applyPageBreak}
      />
      <Divder spacing={1.2} />
    </Box>
  );
}

export default BillingInvoiceDetails;
